import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgSevereIrritationEmojiSecondary from './svgs/SevereIrritationEmojiSecondary.js';
import SvgSevereIrritationEmoji from './svgs/SevereIrritationEmoji.js';
import { useIcon } from '../../shared-components/icon/index.js';

var severeIrritationEmoji = (props => useIcon(SvgSevereIrritationEmoji, SvgSevereIrritationEmojiSecondary, props));

export { severeIrritationEmoji as default };
